























































































import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';
import CreateInventoryView from '@/components/inventory/CreateInventoryView.vue';
// report views
import ActionsSummaryReport from '@/components/inventory/reports/ActionsSummaryReport.vue';
import CostBasisRollForwardReport from '@/components/inventory/reports/CostBasisRollForwardReport.vue';
import CostBasisRollForwardReportOld from '@/components/inventory/reports/CostBasisRollForwardReportOld.vue';
import CustomActionsReport from '@/components/inventory/reports/CustomActionsReport.vue';
import ExpandedCostBasisReport from '@/components/inventory/reports/ExpandedCostBasisReport.vue';
import InventoryActionsReport from '@/components/inventory/reports/InventoryActionsReport.vue';
import InventoryViewReport from '@/components/inventory/reports/InventoryViewReport.vue';
import RolledUpActionsJeSync from '@/components/inventory/reports/RolledUpJeSync.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiDataTable from '@/components/ui/UiDataTable.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';
import UiListItem from '@/components/ui/UiListItem.vue';
import Beta from '@/components/util/Beta.vue';
import WalletListNew from '@/components/wallets/WalletListNew.vue';
import {
  ANALYTICS_ACTIONS_FLAG,
  CustomActionsReport as CustomReport,
  CustomActionsReportSource,
  HttpCustomActionsReportSource,
} from '@/utils/customActionsReports';
import { requestParentToNavigate } from '@/utils/iframeMessageRequester';

import { ApiSvcInventoryView } from '../../../../generated/api-svc';

export interface TabItem {
  title: string;
  value: string;
  featureFlag?: string;
  icon?: string;
  showBeta?: boolean;
}

type ParentNavigator = (path: string, params?: Record<string, unknown>) => void;

@Component({
  components: {
    ActionsSummaryReport,
    CostBasisRollForwardReport,
    CostBasisRollForwardReportOld,
    CustomActionsReport,
    ExpandedCostBasisReport,
    InventoryActionsReport,
    CreateInventoryView,
    UiDatePicker,
    UiButton,
    WalletListNew,
    UiDataTable,
    UiListItem,
    InventoryViewReport,
    RolledUpActionsJeSync,
    Beta,
  },
})
export default class InventoryViewReports extends BaseVue {
  @Prop({ default: null })
  public readonly currentView!: ApiSvcInventoryView | null;

  @Prop({ type: Function, default: requestParentToNavigate })
  public readonly parentNavigator!: ParentNavigator;

  /** Lists the org's custom Actions reports (analytics-query-svc by default). */
  @Prop({ default: () => new HttpCustomActionsReportSource() })
  public readonly customReportSource!: CustomActionsReportSource;

  public viewReport: string | null = null;

  public customReports: CustomReport[] = [];

  /** Custom reports open under `custom:<templateId>`. */
  public get currentCustomReport(): CustomReport | undefined {
    if (!this.viewReport?.startsWith('custom:')) return undefined;
    const id = this.viewReport.slice('custom:'.length);
    return this.customReports.find((r) => r.id === id);
  }

  public openCustomReport(report: CustomReport) {
    this.viewReport = `custom:${report.id}`;
  }

  /** Load the org's custom reports for this view; failures just leave the list empty. */
  public async loadCustomReports() {
    const viewId = this.currentView?.id;
    if (!viewId || !this.checkFeatureFlag(ANALYTICS_ACTIONS_FLAG)) {
      this.customReports = [];
      return;
    }
    try {
      this.customReports = await this.customReportSource.list(this.orgId, viewId);
    } catch {
      this.customReports = [];
    }
  }

  public listItems: TabItem[] = [
    { title: 'Cost Basis Roll Forward', value: 'cost-basis-roll-forward-old', icon: 'fa-regular fa-chart-line' },
    {
      title: 'Cost Basis Roll Forward (Expanded)',
      value: 'cost-basis-roll-forward',
      icon: 'fa-regular fa-chart-line',
      featureFlag: 'cost-basis-roll-forward-v2',
      showBeta: true,
    },
    { title: 'Actions', value: 'actions', icon: 'fa-regular fa-table-list' },
    {
      title: 'Actions Summary',
      value: 'actions-summary-report',
      icon: 'fa-regular fa-table-list',
      featureFlag: 'inventory-view-custom-reports',
    },
    { title: 'Reclass', value: 'je-reclass', icon: 'fa-brands fa-connectdevelop' },
    {
      title: 'GL Detailed Journal Report (Actions)',
      value: 'actions-je-report',
      icon: 'fa-regular fa-receipt',
      showBeta: true,
    },
    {
      title: 'GL Summary Journal Report (Actions)',
      value: 'actions-tb-report',
      icon: 'fa-regular fa-receipt',
      showBeta: true,
    },
    {
      title: 'Actions Trial balance report',
      value: 'actions-trial-balance-report',
      icon: 'fa-regular fa-receipt',
      showBeta: true,
    },
    {
      title: 'Sage ERP JE Import',
      value: 'sage-erp-je-import',
      icon: 'fa-regular fa-receipt',
      featureFlag: 'xrp-custom-reports',
    },
    {
      title: 'Expanded Actions Report',
      value: 'expanded-actions-report',
      icon: 'fa-regular fa-receipt',
      featureFlag: 'xrp-custom-reports',
    },
    {
      title: 'Expanded Cost Basis Report',
      value: 'expanded-cost-basis-report',
      icon: 'fa-regular fa-chart-line',
      featureFlag: 'xrp-custom-reports',
    },
    {
      title: 'Rolled Up Actions JE Sync',
      value: 'rolled-up-actions-je-sync',
      icon: 'fa-brands fa-connectdevelop',
      featureFlag: 'rolled-up-actions-je-sync',
      showBeta: true,
    },
  ];

  mounted() {
    this.navigateToReport();
    this.loadCustomReports();
  }

  @Watch('currentView')
  onViewChanged() {
    this.loadCustomReports();
  }

  // get only items that don't have a feature flag or have a feature flag and it's enabled
  public get listActiveItems() {
    return this.listItems.filter((x) => !x.featureFlag || this.checkFeatureFlag(x.featureFlag));
  }

  public get currentItem() {
    return this.listItems.find((x) => x.value === this.viewReport);
  }

  public isBeta(viewReport: unknown) {
    if (typeof viewReport !== 'string') return false;
    const item = this.listItems.find((x) => x.value === viewReport);
    return item?.showBeta || false;
  }

  public openReport(item: TabItem) {
    if (item.value === 'actions-trial-balance-report') {
      // The Actions trial balance lives in the V3 app. Pass the view when it is known;
      // the V3 report offers a picker otherwise, so the click never dead-ends.
      this.parentNavigator(
        '/reports/actions-trial-balance',
        this.currentView?.id ? { inventoryViewId: this.currentView.id } : undefined
      );
      return;
    }

    this.viewReport = item.value;
  }

  private navigateToReport() {
    const reportParam = this.$route?.query?.report as string;
    if (reportParam) {
      const report = this.listItems.find((item) => item.value === reportParam);

      // confirm that the report specified in the url actually exists
      // verify that the report is not behind a ff or if it is the user has it
      if (report && (!report.featureFlag || this.checkFeatureFlag(report.featureFlag))) {
        // A deep link must follow the same routing as a click, or a V3-hosted report
        // would fall through to the generic inventory-view-report renderer.
        this.openReport(report);
      }
    }
  }
}
